export const REALM_ACCESS_TOKEN_HEADER_TEXT = 'x-realm-access-token';
